import styled from 'styled-components';

export const $BannerContainer = styled.div`
  background: linear-gradient(180deg, #1a1a1e 100%, #1a1a1e 100%);
  color: white;
  border-radius: 16px;
  position: fixed;
  bottom: 24px;
  right: 24px;
  overflow: hidden;
  width: 360px;
  max-height: 700px;
  height: calc(100vh - 100px);
  z-index: 1000;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  cursor: default;
  --banner-height: calc(100vh - 100px);
  container-type: size;
  container-name: banner;
`;

export const $ProgressBarHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 12px 20px 0;
  position: relative;
  z-index: 3;
`;

export const $ProgressBarContainer = styled.div`
  display: flex;
  gap: 4px;
  flex: 1;
`;

export const $ProgressBar = styled.div`
  flex: 1;
  height: 3px;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 2px;
  overflow: hidden;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.4);
  }
`;

export const $ProgressBarFill = styled.div<{ $progress: number }>`
  height: 100%;
  background: white;
  border-radius: 2px;
  width: ${props => props.$progress}%;
  transition: width 0.1s linear;
`;

export const $NavigationButton = styled.button`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;
  z-index: 4;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;

    &:hover {
      background: rgba(255, 255, 255, 0.1);
    }
  }

  svg {
    fill: white;
  }
`;

export const $CloseButton = styled.button`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;
  z-index: 4;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }

  svg {
    fill: white;
  }
`;

export const $CloseButtonOverlay = styled.div`
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 10;
  background: rgba(0, 8, 50, 0.275);
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const $CloseButtonOverlayButton = styled.button`
  background: transparent;
  border: none;
  color: #8a8a9f;
  width: 100%;
  height: 100%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;

  &:hover {
    background: rgba(0, 8, 50, 0.4);
  }

  svg {
    fill: #8a8a9f;
  }
`;
